<article
  class="flex items-start gap-3 border-b border-slate-200 px-3 py-3.5 sm:px-4 cursor-pointer"
  [class]="{
    'bg-sky-100': cajaChat().seleccionado,
    'hover:bg-slate-50': !cajaChat().seleccionado,
  }"
>
  @if (cajaChat().profilePictureUrl) {
    <img
      class="h-10 w-10 shrink-0 rounded-full object-cover"
      [src]="cajaChat().profilePictureUrl"
      [alt]="cajaChat().nombre_contacto"
    />
  } @else {
    <div
      class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-semibold"
      [class]="getColor()"
    >
      {{
        cajaChat().nombre_contacto.length > 2
          ? (cajaChat().nombre_contacto | slice: 0 : 2 | uppercase)
          : 'X'
      }}
    </div>
  }
  <div class="min-w-0 flex-1">
    <div class="flex items-start justify-between gap-3">
      <div class="min-w-0">
        <p class="truncate text-sm font-semibold text-slate-900">
          {{ cajaChat().nombre_contacto }}
        </p>
        <p class="truncate text-xs text-slate-500">{{ cajaChat().numero_contacto }}</p>
      </div>
      <div class="text-right text-xs text-slate-500">
        <p>{{ cajaChat().fecha_ultimo_mensaje | date: 'h:mm a' }}</p>
        @if (cajaChat().mensajes_no_leidos > 0) {
          <span
            class="mt-1 inline-flex rounded-full bg-sky-600 px-2 py-0.5 font-semibold text-white"
            >{{ cajaChat().mensajes_no_leidos }}</span
          >
        }
      </div>
    </div>
    @if (cajaChat().ultimo_mensaje) {
      <p class="mt-1.5 text-sm text-slate-600">
        {{ cajaChat().ultimo_mensaje | slice: 0 : 50
        }}{{ cajaChat().ultimo_mensaje!.length > 50 ? '...' : '' }}
      </p>
    }
    <div class="mt-2 flex flex-wrap gap-2 text-[11px] font-medium">
      @for (tag of cajaChat().tags; track $index) {
        <span
          class="rounded-full px-2 py-1 text-xs font-semibold"
          [style]="{
            'background-color': tag.color_fondo || '#E5E7EB',
            color: tag.color_texto || '#374151',
          }"
        >
          {{ tag.nombre }}
        </span>
      }
    </div>
  </div>
</article>
